( function ( _s ) {
	const getHtml = imgUrl => {
		return `
			<div class="thumbnail-container position-absolute top-0 start-0 w-100 h-100">
				<div class="inner-overlay position-relative w-100 h-100">
					<img src="${ imgUrl }" class="position-absolute top-0 start-0 w-100 h-100" alt="Video overlay." loading="lazy">
					<div class="play-btn" title="Click here to play the video." role="button"></div>
				</div>
			</div>
		`;
	};

	//https://gist.github.com/yangshun/9892961
	const urlParse = url => {
		let type = null;
		url.match(
			/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
		);

		if ( RegExp.$3.indexOf( 'youtu' ) > -1 ) {
			type = 'youtube';
		} else if ( RegExp.$3.indexOf( 'vimeo' ) > -1 ) {
			type = 'vimeo';
		}

		return {
			type: type,
			id: RegExp.$6,
		};
	};

	const onButtonClicked = ( _embedContainer, _iframe, videoType ) => {
		_embedContainer.find( '.play-btn' ).on( 'click', ev => {
			ev.preventDefault();
			var src = _iframe.el[ 0 ].src;
			src += videoType == 'youtube' ? '&autoplay=1' : '&amp;autoplay=true';
			_iframe.el[ 0 ].src = src;

			_embedContainer.find( '.thumbnail-container' ).remove();
		} );
	};

	const initializePreview = ( _self, _iframe, videoObj ) => {
		let thumbnailUrl = '';

		//mark as initialized
		_self.addClass( 'is--initialized' );

		if ( videoObj.type == 'youtube' ) {
			thumbnailUrl = `http://img.youtube.com/vi/${ videoObj.id }/maxresdefault.jpg`;
			_self.append( getHtml( thumbnailUrl ) );

			onButtonClicked( _self, _iframe, videoObj.type );
		}
		if ( videoObj.type == 'vimeo' ) {
			//I'm assuming the url given is a valid youtube url
			fetch( `http://vimeo.com/api/v2/video/${ videoObj.id }.json` )
				.then( response => {
					if ( ! response ) return;
					// The API call was successful!
					thumbnailUrl = data[ 0 ].thumbnail_large;
					_self.append( getHtml( thumbnailUrl ) );

					onButtonClicked( _self, _iframe, videoObj.type );
				} )
				.catch( function ( err ) {
					// There was an error
				} );
		}
	};

	_s.fn.addThumbnailToEmbeddedVideo = function () {
		return this.el.forEach( el => {
			const _self = _s( el );
			const _iframe = _self.find( ':scope > iframe' );
			const url = _iframe.el[ 0 ].getAttribute( 'src' );

			//if no url on the iframe, skip
			if ( ! url ) return;

			const videoObj = urlParse( url );

			//if video not youtuve or vimeo, skip
			if ( videoObj.type == null ) return;

			const observer = new IntersectionObserver( entries => {
				entries.forEach( entry => {
					if ( entry.isIntersecting && ! _self.hasClass( 'is--initialized' ) ) {
						//do the thing
						initializePreview( _self, _iframe, videoObj );
						//unobserve after animation is done
						observer.unobserve( entry.target );
					}
				} );
			} );

			observer.observe( _self.el[ 0 ] );
		} );
	};

	_s( document ).ready( () => {
		_s( '.video-embed' ).addThumbnailToEmbeddedVideo();
	} );
} )( window._s );
